module.exports = __webpack_public_path__ + "static/media/gps-verde.a182f761.svg";